import { Box, Collapse, Typography } from '@mui/material'
import React from 'react'
import { useLocation } from 'react-router'
import { CHILD_ROUTES, ROUTES } from '../../helpers/routes-helper'
import useAppUtilities from '../../hooks/useAppUtilities'

interface RestaurantChildrenMenuProps {
  open: boolean
}

const RestaurantChildrenMenu: React.FC<RestaurantChildrenMenuProps> = ({
  open,
}) => {
  const { navigate } = useAppUtilities()
  const location = useLocation()
  const menuItems = [
    {
      label: 'Campaigns',
      path: `${ROUTES.RESTAURANT_INFLUENCER}/${CHILD_ROUTES.RESTAURANT_CAMPAIGNS}`,
    },
    {
      label: 'Collab Inbox',
      path: `${ROUTES.RESTAURANT_INFLUENCER}/${CHILD_ROUTES.RESTAURANT_COLLAB_INBOX}`,
    },
    {
      label: 'Find Creators',
      path: `${ROUTES.RESTAURANT_INFLUENCER}/${CHILD_ROUTES.RESTAURANT_FIND_CREATORS}`,
    },
  ]

  const handleMenuItemClick = (path: string): void => {
    navigate(path)
  }

  return (
    <Collapse in={open} timeout="auto" unmountOnExit>
      <Box my="13px" border={1} pl="16px">
        {menuItems.map((item, index) => (
          <Box key={index} display="flex" alignItems="end" position="relative">
            <Box
              sx={{
                height: `${index === 0 ? 50 / 2 : 50}px`,
                borderLeft: '2px solid',
                width: '15px',
                borderBottom: '2px solid',
                borderBottomLeftRadius: '8px',
                marginTop: '-5px',
                borderColor: 'primary.900',
              }}
            ></Box>
            <Box
              position="absolute"
              bottom={index === 0 ? '-55%' : '-20%'}
              left={23}
              sx={{ cursor: 'pointer', zIndex: 10 }}
            >
              <Typography
                color={
                  item.path === location.pathname ? 'common.white' : 'grey.400'
                }
                variant="subtitle1"
                sx={{
                  lineHeight: '24px',
                }}
                fontWeight={500}
                onClick={() => handleMenuItemClick(item.path)}
              >
                {item.label}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Collapse>
  )
}

export default RestaurantChildrenMenu
